import { INSTRUMENT_CODES } from 'const'
import StringInstrument from 'components/Tools/Sections/StringInstrument'
import ToolLayout from 'layouts/ToolLayout'
import UkuleleJSON from 'assets/chords/ukulele.json'

const ToolPageUkuleleSlackKey = () => {
  return (
    <ToolLayout>
      <StringInstrument
        tuning="slack-key"
        instrumentCode={INSTRUMENT_CODES.ukulele}
        stringChordLibraryJSON={UkuleleJSON}
      />
    </ToolLayout>
  )
}

export default ToolPageUkuleleSlackKey
